module.exports = "<div class=\"inspiration-centre-panel\">\r\n\t<wow-card-list>\r\n\t\t<wow-inspiration-card-list page-id=\"pageId\"></wow-inspiration-card-list>\r\n\t</wow-card-list>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/inspiration/inspiration-center-panel-template.html
 ** module id = 87
 ** module chunks = 1
 **/